<div class="my-3"><i>Ports are synced to WPCS refdata</i></div>
<div class="row">
  <div class="col-md-6">
    <app-form-group><label>Id</label><input class="form-control" [(ngModel)]="port['id']" disabled required></app-form-group>
    <app-form-group><label>Name</label><input class="form-control" [(ngModel)]="port.name" required></app-form-group>
    <app-form-group><label>Location unCode</label><input class="form-control" [(ngModel)]="port.locationUnCode" required></app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group label="Country">
      <app-search required [ngModel]="port.countryUnCode" [searchFunction]="utils.findCountries"
                  (ngModelChange)="port.countryUnCode = $event?.code" [resultFormatter]="utils.countryFormatter">
      </app-search>
    </app-form-group>
    <app-form-group><label>EU port</label><app-yes-no [(ngModel)]="port.euPort" required id="euPort"></app-yes-no></app-form-group>
  </div>
</div>
